"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.FalconNavigatorHeader = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const React = __importStar(require("react"));
class FalconNavigatorHeader extends React.Component {
    constructor() {
        super(...arguments);
        this.defaultBackButtonLabel = "Back";
    }
    render() {
        return (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [this.renderBack(), this.renderTitle(), this.props.children] });
    }
    renderTitle() {
        if (!this.props.title) {
            return undefined;
        }
        if (typeof this.props.title === "string") {
            return this.renderStringTitle(this.props.title);
        }
        return this.renderObjectTitle(this.props.title);
    }
    renderBack() {
        if (!this.props.back) {
            return undefined;
        }
        if (typeof this.props.back === "string") {
            return this.renderStringBack(this.props.back);
        }
        return this.renderObjectBack(this.props.back);
    }
    renderStringTitle(title) {
        if (!title) {
            return undefined;
        }
        return ((0, jsx_runtime_1.jsx)("div", { className: "text-group title plugin no-indent-desktop", children: (0, jsx_runtime_1.jsx)("h1", { className: this.props.children ? "mb-2" : "m-0", children: title }) }));
    }
    renderObjectTitle(titleProps) {
        if (titleProps.hidden || (!titleProps.label && !titleProps.html)) {
            return undefined;
        }
        if (titleProps.html) {
            return titleProps.html;
        }
        return this.renderStringTitle(titleProps.label);
    }
    renderStringBack(link) {
        return this.renderBackLink(this.defaultBackButtonLabel, true, link);
    }
    renderObjectBack(backProps) {
        var _a;
        if (backProps.hidden || (!backProps.link && !backProps.html && !backProps.action)) {
            return undefined;
        }
        if (backProps.html) {
            return backProps.html;
        }
        if (!backProps.action) {
            return this
                .renderBackLink((_a = backProps.label) !== null && _a !== void 0 ? _a : this.defaultBackButtonLabel, true, backProps.link);
        }
        else {
            return ((0, jsx_runtime_1.jsx)("div", { className: "back-link-top", children: (0, jsx_runtime_1.jsx)("button", { type: "button", className: "btn btn-back-link", onClick: backProps.action, children: "Back" }) }));
        }
    }
    renderBackLink(buttonName, isTop, link) {
        const onClick = link ?
            () => { window.location.href = link; } :
            () => { window.history.back(); };
        return ((0, jsx_runtime_1.jsx)("div", { className: `${isTop ? "back-link-top" : "back-link-bottom"}`, children: (0, jsx_runtime_1.jsx)("button", { type: "button", className: "btn btn-back-link", onClick: onClick, children: buttonName }) }));
    }
}
exports.FalconNavigatorHeader = FalconNavigatorHeader;
//# sourceMappingURL=FalconNavigatorHeader.js.map